import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  createContext,
  useMemo,
} from 'react';
import { useAuth } from 'hooks/auth';
import { useCadDespolpador } from 'hooks/providers/cadastros/cadastroRastreabilidade/despolpadores';

const SelectDespolpadorContext = createContext({});

export function SelectDespolpadorProvider({ children }) {
  const { isAuth, token } = useAuth();
  const { addDespolpador, editDespolpador } = useCadDespolpador();

  const [dados, setDados] = useState({});
  const [options, setOptions] = useState([]);

  const onSubmitInsert = useCallback(
    async (data, onChange) => {
      try {
        const response = await addDespolpador(data);

        if (response) {
          setDados(response);
          setOptions((old) => [...old, response]);
          onChange(response);
        }
      } finally {
      }
    },
    [addDespolpador],
  );

  const onSubmitUpdate = useCallback(
    async (id, data, onChange) => {
      try {
        const response = await editDespolpador({ id, ...data });

        if (response) {
          setOptions((old) =>
            old.map((item) =>
              Number(item.id) === Number(id) ? { ...item, ...response } : item,
            ),
          );
          setDados(response);
          onChange(response);
        }
      } finally {
      }
    },
    [editDespolpador],
  );

  useEffect(() => {
    if (!isAuth && token === 'initial') {
      setDados([]);
    }
  }, [isAuth, token]);

  const value = useMemo(
    () => ({
      onSubmitInsert,
      onSubmitUpdate,
      dados,
      setDados,
      options,
      setOptions,
    }),
    [onSubmitInsert, onSubmitUpdate, dados, options],
  );

  return (
    <SelectDespolpadorContext.Provider value={value}>
      {children}
    </SelectDespolpadorContext.Provider>
  );
}

export function useSelectDespolpador() {
  const context = useContext(SelectDespolpadorContext);

  if (!context)
    throw new Error('useSelectDespolpador must be used within an AuthProvider');

  return context;
}
